import { ArrowUpRight, Check } from "lucide-react";
import { SERVICES } from "@/data/services";

export default function Services({ onBookService }) {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 bg-[#0A0A0C]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-[0.28em] text-[#D4AF37] font-semibold mb-3">
              Our Services
            </p>
            <h2 className="text-3xl md:text-5xl font-semibold tracking-tighter text-white">
              Seven specialties.
              <span className="block text-white/55">One trusted crew.</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-md text-base md:text-lg leading-relaxed">
            Transparent flat-rate pricing. Same-week booking. Background-checked installers
            who treat your home like their own.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, idx) => (
            <ServiceCard
              key={s.id}
              service={s}
              onBook={() => onBookService(s)}
              featured={idx === 0}
              wide={idx === 6}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ service, onBook, featured, wide }) {
  return (
    <article
      data-testid={`service-card-${service.id}`}
      className={`group relative flex flex-col bg-[#121216] border border-white/10 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:border-[#D4AF37]/50 hover:shadow-[0_25px_60px_-20px_rgba(212,175,55,0.25)] ${
        wide ? "lg:col-span-3" : ""
      }`}
    >
      <div className={`relative overflow-hidden ${wide ? "h-72" : "h-56"}`}>
        <img
          src={service.image}
          alt={service.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#121216] via-transparent to-transparent" />
        <div
          data-testid={`service-price-${service.id}`}
          className="absolute top-4 left-4 px-3 py-1.5 rounded-full bg-black/60 backdrop-blur-md border border-[#D4AF37]/40 text-[#D4AF37] text-xs font-semibold tracking-wide"
        >
          Starting at ${service.starting_price}
        </div>
      </div>

      <div className="flex-1 flex flex-col p-6 md:p-7">
        <h3 className="text-xl md:text-2xl font-semibold text-white tracking-tight">
          {service.title}
        </h3>
        <p className="mt-2 text-sm md:text-[15px] text-white/60 leading-relaxed">
          {service.short}
        </p>

        <ul className="mt-4 space-y-1.5">
          {service.features.map((f) => (
            <li
              key={f}
              className="flex items-center gap-2 text-xs text-white/50"
            >
              <Check size={13} className="text-[#D4AF37] shrink-0" />
              <span>{f}</span>
            </li>
          ))}
        </ul>

        <button
          data-testid={`book-now-${service.id}`}
          onClick={onBook}
          className="mt-6 group/btn flex items-center justify-between w-full px-5 py-3 rounded-full bg-white/5 border border-white/10 text-white text-sm font-medium hover:bg-[#D4AF37] hover:text-black hover:border-[#D4AF37] transition-all duration-300"
        >
          <span>Book Now</span>
          <ArrowUpRight
            size={16}
            className="transition-transform duration-300 group-hover/btn:rotate-45"
          />
        </button>
      </div>
    </article>
  );
}
